import { Appointment } from "@elixir/types";
import { ReactComponent as FileRegularIcon } from "../../../../assets/icons/font-awesome/file-regular.svg";
import { initMedicalCertificate } from "../../../../utils/bridges/methods";
import { ChipWithTooltip } from "ui";

const CreateMedicalCertifcate = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  return (
    <ChipWithTooltip
      onClick={() => {
        initMedicalCertificate(apt);
      }}
      className={`h-32 flex-1 ${className}`}
      icon={<FileRegularIcon className="dr-min-w-14 dr-h-14" />}
      title="Create Medical Certificate"
      tooltipText="Create Medical Certificate"
      type={type}
    />
  );
};

export default CreateMedicalCertifcate;
